<form [formGroup]="selectorForm" class="flex flex-col justify-between items-center">
  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Workspace</mat-label>
    <mat-select value='Select workspace'
                formControlName="expertServiceWorkspace">
      <mat-option *ngFor="let expertServiceWorkspace of expertServiceWorkspaces"
                  [value]="expertServiceWorkspace">{{expertServiceWorkspace.name}}</mat-option>
    </mat-select>
    <mat-error
      *ngIf="selectorForm.get('expertServiceWorkspace').hasError('required') ||selectorForm.get('expertServiceWorkspace').invalid && (selectorForm.get('expertServiceWorkspace').dirty || selectorForm.get('expertServiceWorkspace').touched)">
      Please choose a service provider
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Service</mat-label>
    <mat-select value='Select Service'
                formControlName="selectedService">
      <mat-option *ngFor="let expertService of expertServices"
                  [value]="expertService">{{expertService.title}}</mat-option>
    </mat-select>
    <mat-error
      *ngIf="selectorForm.get('selectedService').hasError('required') || selectorForm.get('selectedService').invalid && (selectorForm.get('selectedService').dirty || selectorForm.get('selectedService').touched)">
      Please choose a service
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Message</mat-label>
    <textarea matInput type="text" [(ngModel)]="data.input.message"
              formControlName="message"
              placeholder="Enter message" rows="5">
              </textarea>
  </mat-form-field>
</form>
